// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"165":"2c1089c2","587":"cf30201a","650":"18f415d3","722":"c9fe2461"}[chunkId] + ".chunk.css";
};